module.exports = __webpack_public_path__ + "img/login-logo.99306541.png";